// extracted by mini-css-extract-plugin
module.exports = {"albumTypes":"TypeItems-albumTypes-3dH6W"};